import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "switch"
};
const _hoisted_2 = {
  class: "icon_box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavBar = _resolveComponent("NavBar");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_icon = _resolveComponent("van-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
    title: "账号绑定"
  }), _cache[2] || (_cache[2] = _createElementVNode("p", null, "轻触头像以切换账号", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (item, index) => {
    return _openBlock(), _createBlock(_component_van_cell_group, {
      inset: "",
      key: index,
      class: "mt8"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        center: "",
        clickable: "",
        onClick: $event => _ctx.userSwitch(item, index)
      }, _createSlots({
        title: _withCtx(() => [_createVNode(_component_van_image, {
          src: item.photoPath,
          fit: "cover"
        }, null, 8, ["src"]), _createElementVNode("span", null, _toDisplayString(item.name), 1)]),
        _: 2
      }, [index === 0 ? {
        name: "value",
        fn: _withCtx(() => [_createVNode(_component_van_tag, {
          color: "#5282f0",
          size: "medium"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("当前登录")])),
          _: 1
        })]),
        key: "0"
      } : undefined]), 1032, ["onClick"])]),
      _: 2
    }, 1024);
  }), 128)), _createVNode(_component_van_cell_group, {
    inset: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      class: "last_item",
      to: "/bind"
    }, {
      title: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
        name: "plus",
        color: "#e8e8e8",
        size: "26"
      })]), _cache[1] || (_cache[1] = _createTextVNode(" 绑定其他账号 "))]),
      _: 1
    })]),
    _: 1
  })]);
}